import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";

import apiResourceSheet from "api/resource_sheet";
import { RemoteUrlEnum } from "core/enums";

export const fetchResourceSheetList = createAsyncThunk("resourceSheet/fetchResourceSheetList", async ({ limit }, { rejectWithValue }) => {
	try {
		const response = await apiResourceSheet.getList({ limit });
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

export const postResSheetIdLifeMap = createAsyncThunk("resourceSheet/postResSheetIdLifeMap", async ({ resSheetId }, { rejectWithValue }) => {
	const response = await apiResourceSheet.postResSheetIdLifeMap({ resSheetId });
	window.open(`${RemoteUrlEnum.LIFE_MAP}?city_id=${response.data.city_id}`);
	return response.data;
});

export const resourceSheetSlice = createSlice({
	name: "resourceSheetSlice",
	fetchStatus: null,
	fetchStatusText: null,
	initialState: {
		table: {
			data: [],
			selectedData: [],
		},
		defaultCreationOpts: null,
	},
	reducers: {
		updateResourceSheetData: (state, { payload }) => {
			state.table.data = payload;
		},
		updateFetchStatus: (state, { payload }) => {
			state.fetchStatus = payload;
		},
		updateFetchStatusText: (state, { payload }) => {
			state.fetchStatusText = payload;
		},
		updateDefaultCreationOpts: (state, { payload }) => {
			state.defaultCreationOpts = { ...state.defaultCreationOpts, ...payload };
		},
		clearDefaultCreationOpts: (state, { payload }) => {
			state.defaultCreationOpts = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchResourceSheetList.fulfilled, (state, { payload }) => {
			state.fetchStatus = "success";
			state.table["data"] = payload;
		});

		builder.addMatcher(isAnyOf(fetchResourceSheetList.pending), (state, action) => {
			state.fetchStatus = "loading";
		});

		builder.addMatcher(isAnyOf(fetchResourceSheetList.rejected), (state, { payload }) => {
			state.fetchStatus = "failed";
			state.fetchStatusText = payload?.detail;
		});
	},
});

export const { updateResourceSheetData, updateFetchStatus, updateFetchStatusText, updateDefaultCreationOpts, clearDefaultCreationOpts } =
	resourceSheetSlice.actions;
export default resourceSheetSlice.reducer;
